/*
 * megamenu-collection-preview.js
 * Affiche un aperçu (image + titre) de la collection au survol d'un
 * grand-enfant de mega-menu pointant vers une collection.
 *
 * Markup attendu (rendu par snippets/mega-menu-list.liquid) :
 *   - <a data-megamenu-preview-target="{id}" data-collection-handle="..."
 *        data-collection-image-url="..." data-collection-image-alt="...">...</a>
 *   - <div class="mega-menu__collection-preview" data-megamenu-preview="{id}">
 *       <img class="mega-menu__collection-preview-image">
 *       <div class="mega-menu__collection-preview-title"></div>
 *     </div>
 *
 * Idempotent (window flag), no-op sur touch-only devices.
 */
(function () {
  if (window.__megamenuCollectionPreviewInit) return;
  window.__megamenuCollectionPreviewInit = true;

  var HIDE_DELAY_MS = 120;
  var attached = new WeakSet();

  function bindSlot(slot) {
    if (attached.has(slot)) return;
    attached.add(slot);

    var slotId = slot.getAttribute('data-megamenu-preview');
    if (!slotId) return;

    var img = slot.querySelector('.mega-menu__collection-preview-image');
    var title = slot.querySelector('.mega-menu__collection-preview-title');
    if (!img) return;

    var menuList = document.querySelector('[data-menu-list-id="' + slotId + '"]');
    if (!menuList) return;

    // Scope au plus proche parent commun pour éviter de capturer des links
    // d'autres mega-menus présents sur la page.
    var scope = menuList.parentNode || menuList;
    var links = scope.querySelectorAll('a[data-megamenu-preview-target="' + slotId + '"][data-collection-image-url]');
    if (!links.length) return;

    var hideTimer = null;

    function show(link) {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      var url = link.getAttribute('data-collection-image-url');
      var alt = link.getAttribute('data-collection-image-alt') || '';
      if (!url) return;
      if (img.getAttribute('src') !== url) {
        img.setAttribute('src', url);
        img.setAttribute('alt', alt);
      }
      if (title) title.textContent = alt;
      slot.classList.add('is-visible');
      slot.setAttribute('aria-hidden', 'false');
    }

    function hide() {
      hideTimer = setTimeout(function () {
        slot.classList.remove('is-visible');
        slot.setAttribute('aria-hidden', 'true');
      }, HIDE_DELAY_MS);
    }

    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener('mouseenter', function () { show(link); });
      link.addEventListener('focus', function () { show(link); });
      link.addEventListener('mouseleave', hide);
      link.addEventListener('blur', hide);
    });

    // Ne pas cacher tant que le curseur reste sur le slot (UX : on peut
    // déplacer la souris vers l'image sans flicker).
    slot.addEventListener('mouseenter', function () {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
    });
    slot.addEventListener('mouseleave', hide);
  }

  function init() {
    // Skip pure touch devices (pas de hover utile).
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

    var slots = document.querySelectorAll('[data-megamenu-preview]');
    Array.prototype.forEach.call(slots, bindSlot);

    // Le header Shopify peut être re-rendu via Section Rendering API.
    // On observe le DOM pour binder les nouveaux slots qui apparaissent.
    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches('[data-megamenu-preview]')) {
              bindSlot(node);
            }
            if (node.querySelectorAll) {
              var nested = node.querySelectorAll('[data-megamenu-preview]');
              Array.prototype.forEach.call(nested, bindSlot);
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
